import {appConfig} from '../../app.config';

export class AssetPhoto {
  media?: {photos: {lowResImageUrl: string, highResImageUrl: string}[]};
  assetAlreadyEquip: boolean;
  brochurePhoto: string;
  saleType: string;

  public static fromJson(assetPhotoJson: any): AssetPhoto {
    return Object.assign(new AssetPhoto(), assetPhotoJson);
  }

  public static constructBrochurePhotoUrl(brochurePhotoPath: string, saleType: string): string {
    const isBrochurePhotoPathValid = !!brochurePhotoPath;
    let defaultPhotoUrl = appConfig.defaultPhotoUrlForNonPhotoItem;
    if (saleType && saleType === 'LIVE') {
      defaultPhotoUrl = appConfig.defaultPhotoUrlForNonPhotoRBItem;
    }
    return isBrochurePhotoPathValid
      ? brochurePhotoPath
      : defaultPhotoUrl;
  }
}
